export const prerender = true;
export const trailingSlash = 'always';

// if (typeof window !== 'undefined') import('../pwa');